import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Plus } from 'lucide-react'
import { PageLayout } from '@/components/layout/PageLayout'
import { PageHeader } from '@/components/layout/PageHeader'
import { PageHeaderActions } from '@/components/layout/PageHeaderActions'
import { Button } from '@/components/shadcn/button'
import type { DetailedWalletTypeResponse } from '@/api/model'
import { WalletTypesTable } from './table-components/WalletTypesTable'
import { WalletTypeDialog } from './components/WalletTypeDialog'

export default function WalletTypesPage() {
  const { t } = useTranslation('wallet-types')
  const [createOpen, setCreateOpen] = useState(false)
  const [editing, setEditing] = useState<DetailedWalletTypeResponse | null>(null)

  return (
    <PageLayout>
      <PageHeader title={t('header.title')} description={t('header.description')}>
        <PageHeaderActions>
          <Button className="gap-2" onClick={() => setCreateOpen(true)}>
            <Plus className="h-4 w-4" />
            <span className="hidden sm:inline">{t('actions.create')}</span>
          </Button>
        </PageHeaderActions>
      </PageHeader>

      <WalletTypesTable onEdit={setEditing} />

      <WalletTypeDialog
        open={createOpen}
        onClose={() => setCreateOpen(false)}
      />
      <WalletTypeDialog
        open={!!editing}
        onClose={() => setEditing(null)}
        editing={editing}
      />
    </PageLayout>
  )
}
